// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"d1d6e144","217":"c7bdafe5","472":"67402b10","689":"c4ded368","801":"47f55919"}[chunkId] + ".chunk.js";
};